module.exports = {
      id: "extrato-transacoes-usage",
      viewBox: "0 0 150 90",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#extrato-transacoes",
      toString: function () {
        return this.url;
      }
    }